import * as signalR from "@microsoft/signalr";
import { delay } from "./utils/time";
import logger from "./utils/logger";
import config from "./utils/config";
let connection = undefined;
const firstTimeoutPeriod = 1000;
const secondTimeoutPeriod = 5000;
const firstFailThreshold = 5;
const secondFailThreshold = 10;
export default async function getAuctionHub() {
    connection !== null && connection !== void 0 ? connection : (connection = getAuctionHubRepeat());
    return connection;
}
async function getAuctionHubRepeat() {
    if (connection)
        return connection;
    let failCounter = 0;
    while (true) {
        const connected = await createAuctionHub();
        if (connected) {
            return connected;
        }
        failCounter++;
        if (failCounter > secondFailThreshold) {
            // Reload page and start over
            logger.warn("Failed to reconnect to SignalR. Reloading page.");
            window.location.reload();
            return undefined;
        }
        const delayTimeout = failCounter > firstFailThreshold
            ? secondTimeoutPeriod
            : firstTimeoutPeriod;
        await delay(delayTimeout);
    }
}
async function createAuctionHub() {
    // ____
    // Hub is always created with the following options making reconnection working properly
    // withAutomaticReconnect, keepAliveIntervalInMilliseconds (15s), onreconnected
    // ____
    // - after automatic reconnection client gets new clientId and somehow hub is not aware of him
    // - we need to recreate whole connection object
    // - disconnection appears after UI components initialization where all functions subscriptions happen
    // - we decided to reload page to reinit both connection and UI components (connection break happens only from time to time)
    // - if you want to test connection breaking save signalR object to window and call it form browser console:
    //window.signalR = connection;
    //signalR.connection.stopInternal();
    const connection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(config.auctionHubUrl)
        .build();
    connection.keepAliveIntervalInMilliseconds = 1000 * 15;
    connection.onreconnected(async () => { window.location.reload(); });
    try {
        await connection.start();
    }
    catch (err) {
        logger.error(err);
        return undefined;
    }
    return {
        async watchLot(lotId, bidPlacedCallback, lotUpdatedCallback) {
            await connection.invoke("watchLot", lotId);
            let queue = Promise.resolve();
            let lotUpdatedQueue = Promise.resolve();
            const bidPlacedEventHandler = (lot) => {
                if (lot.id === lotId) {
                    queue = queue.then(() => bidPlacedCallback(lot));
                }
            };
            const lotUpdatedHandler = (data) => {
                if (data.id !== lotId)
                    return;
                lotUpdatedQueue = lotUpdatedQueue.then(() => lotUpdatedCallback(data));
            };
            connection.on("bidPlaced", bidPlacedEventHandler);
            connection.on("lotUpdated", lotUpdatedHandler);
            return async () => {
                connection.off("bidPlaced", bidPlacedEventHandler);
                connection.off("lotUpdated", lotUpdatedHandler);
                await connection.invoke("unwatchLot", lotId);
            };
        },
        async watchPodium(callback) {
            await connection.invoke("watchPodium");
            let queue = Promise.resolve();
            const eventHandler = (podiumChanged) => {
                queue = queue.then(() => callback(podiumChanged));
            };
            connection.on("currentPodiumLotChanged", eventHandler);
            return async () => {
                connection.off("currentPodiumLotChanged", eventHandler);
                await connection.invoke("unwatchPodium");
            };
        },
        onOutBid(callback) {
            let queue = Promise.resolve();
            connection.on("outBid", (notification) => {
                queue = queue.then(() => {
                    return callback(notification);
                });
            });
        },
        onLiveAuctionChanged(callback) {
            connection.on("liveAuctionChanged", callback);
        },
        onLiveAuctionRegistrationChanged(callback) {
            connection.on("liveAuctionRegistrationChanged", callback);
        },
        notificationAck(id) {
            return connection.send("notificationAck", id);
        },
        closeConnection() {
            return connection.stop();
        },
    };
}
